export class PhoneVerificationModel {

    constructor(
        public Id: string,
        public VerficationCode: string,
        public verifiedNumber: string,
    ) { }
}
